import type { Cottage } from '../entities/Cottage'
import type {
  HeadInfo,
  HeadInfoImageArr,
} from '~/modules/head/entities/HeadInfo'
import { cleanHTMLTags } from '#imports'

const setTitle = (cottage: Cottage): string => {
  return t('views.cottage.seo.title', cottage.name, cottage.village.name)
}

const setImageItem = (
  item: Cottage['media'][number],
): HeadInfoImageArr[number] => {
  const imageItem: HeadInfoImageArr[number] = {
    url: item.url,
    alt: item.alt,
  }
  return imageItem
}

const setImagesArray = (imgArray: Cottage['media']): HeadInfoImageArr => {
  if (imgArray.length > 0) {
    const tempArr: HeadInfoImageArr = [setImageItem(imgArray[0])]
    return tempArr
  } else {
    const tempArr: HeadInfoImageArr = [
      setImageItem({ url: '', alt: '', type: 'PHOTO', width: 0, height: 0 }),
    ]
    return tempArr
  }
}

const decoratorCottageToHeadInfo = (
  cottage: Cottage,
  options: { robotsVisible: boolean } | undefined = { robotsVisible: true },
): HeadInfo => {
  const title = setTitle(cottage)
  const description = cleanHTMLTags(cottage.description)

  const images = setImagesArray(cottage.media)

  const headInfoInstance: HeadInfo = {
    title,
    description,
    images,
    robotsVisible: options.robotsVisible,
  }

  return headInfoInstance
}

export default decoratorCottageToHeadInfo
